// Modules
import React from 'react';

// Material-ui
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Snackbar, { snackbarClasses } from '@mui/material/Snackbar';

// Helpers
import { COLORS } from '@/lib/helpers';

// Components
// Common components

type PrimarySnackbarProps = {
  handleClose: () => void;
  message: string;
  children?: React.ReactElement;
  open?: boolean;
  sx?: any;
};

const PrimarySnackbar = styled(
  ({ handleClose, message, children, ...props }: PrimarySnackbarProps) => (
    <Snackbar
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      message={message}
      action={
        <IconButton onClick={handleClose}>
          <CloseIcon sx={{ color: COLORS.WHITE }} />
        </IconButton>
      }
      {...props}
    >
      {children}
    </Snackbar>
  )
)({
  [`& .${snackbarClasses.root}`]: {
    backgroundColor: COLORS.BLACK,
    color: COLORS.WHITE,
    fontSize: '0.875rem',
  },
});

export default PrimarySnackbar;
